import { animate, stagger, timeline } from "motion";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";

const Navigation = () => {
  const navEl = document.querySelector('[x-data="menu"]');
  const navItemEls = navEl.querySelectorAll(".nav-item, .gp-btn");

  if (!navEl) {
    return;
  }

  document.addEventListener("nav:toggle", (e) => {
    if (e.detail) {
      openNav();
    } else {
      closeNav();
    }
  });

  const openNav = () => {
    document.body.classList.add('nav-open');
    disableBodyScroll(navEl);

    timeline([
      [navEl, { y: 0 }, { duration: 0.6, easing: [0.25, 0.1, 0.25, 1] }],
      [
        navItemEls,
        { opacity: 1 },
        {
          duration: 0.42,
          delay: stagger(0.15),
          easing: [0.25, 0.1, 0.25, 1],
          at: "-0.2",
        },
      ],
    ]);
  };

  const closeNav = (duration = 0.3) => {
    document.body.classList.remove("nav-open");
    enableBodyScroll(navEl);

    timeline([
      [
        navEl,
        { y: "-100%" },
        { duration: duration, easing: [0.25, 0.1, 0.25, 1] },
      ],
      [
        navItemEls,
        { opacity: 0 },
        {
          duration: duration,
          easing: [0.25, 0.1, 0.25, 1],
        },
      ],
    ]);
  };

  closeNav(0);
};

export default Navigation;
